import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import DashboardSingleData from "../model/DashboardSingeData";

export default class DashboardNumberChartMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, mediatorManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory);
        this._mediatorManager = mediatorManager;
        this._languagePack = languagePack;
    }

    initialize() {
        super.initialize();
    }

    destroy() {
        super.destroy();
    }

    setArrow(increase, positive) {
        if (increase) {
            this._target.Trend.gotoAndStop(positive ? 2 : 1);
        } else {
            this._target.Trend.gotoAndStop(positive ? 0 : 3);
        }
    }

     /**
     * @param {DashboardSingleData} dashboardSingleData 
     */
    setData(dashboardSingleData, showTrend = true) {
        this._target.DataTitleTextField.text = dashboardSingleData.description;
        this._target.DataNrTextField.text = dashboardSingleData.number;


        this._target.TrendIndicatorGoodTextField.text = dashboardSingleData.percent.toFixed(1) + "%";
        this._target.TrendIndicatorBadTextField.text = dashboardSingleData.percent.toFixed(1) + "%";
        
        if (!showTrend || dashboardSingleData.percent == 0) {
            this._target.TrendIndicatorGoodTextField.alpha = 0;
            this._target.TrendIndicatorBadTextField.alpha = 0;
            this._target.Trend.alpha = 0;
            return
        }
        

        this._target.TrendIndicatorGoodTextField.alpha =
        (dashboardSingleData.positive && dashboardSingleData.increase) || (!dashboardSingleData.positive && !dashboardSingleData.increase) ? 1 : 0;
        this._target.TrendIndicatorBadTextField.alpha =
        (dashboardSingleData.positive && dashboardSingleData.increase) || (!dashboardSingleData.positive && !dashboardSingleData.increase) ? 0 : 1;


        this.setArrow(dashboardSingleData.increase, dashboardSingleData.positive);
    }
}